module.exports = __webpack_public_path__ + "img/1512015842.60eb07a8.jpg";